/* ============================================================
   The Gift Wholesalers — Custom Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────
     NAVIGATION FIX
  ──────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
    const href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('javascript:') ||
        href.startsWith('mailto:') || href.startsWith('tel:')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.location.assign(href);
  }, true);

  /* ──────────────────────────────────────────
     HISTORY — tracks searches + product views
  ──────────────────────────────────────────── */
  const BDHistory = {
    SEARCH_KEY: 'bd_searches',
    VIEW_KEY:   'bd_views',
    MAX: 10,

    addSearch(q) {
      try {
        const list = this._get(this.SEARCH_KEY).filter(s => s !== q);
        list.unshift(q);
        localStorage.setItem(this.SEARCH_KEY, JSON.stringify(list.slice(0, this.MAX)));
      } catch (_) {}
    },

    addView(title) {
      try {
        const list = this._get(this.VIEW_KEY).filter(s => s !== title);
        list.unshift(title);
        localStorage.setItem(this.VIEW_KEY, JSON.stringify(list.slice(0, this.MAX)));
      } catch (_) {}
    },

    getSearches() { return this._get(this.SEARCH_KEY); },
    getViews()    { return this._get(this.VIEW_KEY); },

    _get(key) {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; }
    }
  };

  /* ──────────────────────────────────────────
     SEARCH — Shopify predictive search
  ──────────────────────────────────────────── */
  const BDSearch = {
    input:    null,
    dropdown: null,
    timer:    null,
    MIN:      2,

    init() {
      this.input    = document.querySelector('.bdh-srch__input, .bd-search-bar input[name="q"]');
      this.dropdown = document.querySelector('.bd-search-dropdown');
      if (!this.input || !this.dropdown) return;

      this.input.addEventListener('input',   () => this._onInput());
      this.input.addEventListener('focus',   () => this._onFocus());
      this.input.addEventListener('keydown', (e) => this._onKey(e));

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.bd-search-wrap, .bdh-srch')) this._close();
      });

      const mic = document.querySelector('.bd-search-mic, .bdh-srch__mic');
      if (mic) mic.addEventListener('click', () => this._voiceSearch());
    },

    _onInput() {
      clearTimeout(this.timer);
      const q = this.input.value.trim();
      if (q.length < this.MIN) { this._close(); return; }
      this._showLoading();
      this.timer = setTimeout(() => this._fetch(q), 300);
    },

    _onFocus() {
      const q = this.input.value.trim();
      if (q.length >= this.MIN) this._fetch(q);
    },

    _onKey(e) {
      if (e.key === 'Escape') { this._close(); this.input.blur(); }
      if (e.key === 'Enter') {
        e.preventDefault();
        const q = this.input.value.trim();
        if (q) {
          BDHistory.addSearch(q);
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      }
    },

    async _fetch(q) {
      try {
        const base = (window.routes?.predictive_search_url || '/search/suggest') + '.json';
        const url  = base + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8' +
          '&resources[options][unavailable_products]=hide' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,body_html';
        const res  = await fetch(url);
        const json = await res.json();
        this._render(json.resources?.results?.products || [], q);
      } catch (_) { this._close(); }
    },

    _showLoading() {
      this.dropdown.innerHTML =
        '<div class="bd-search-loading"><div class="bd-spinner"></div><span>Searching...</span></div>';
      this.dropdown.classList.add('active');
    },

    _render(products, q) {
      const seeAllUrl = '/search?q=' + encodeURIComponent(q) + '&type=product';

      if (!products.length) {
        this.dropdown.innerHTML =
          '<div class="bd-search-no-results">' +
            '<div style="font-size:32px;margin-bottom:8px">🔍</div>' +
            '<strong>No results for "' + this._esc(q) + '"</strong>' +
            '<div style="font-size:12px;margin-top:4px;color:#999">Try different keywords</div>' +
          '</div>';
        this.dropdown.classList.add('active');
        return;
      }

      BDHistory.addSearch(q);

      const hl = (text, term) => {
        const re = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
        return this._esc(text).replace(re,
          '<mark style="background:rgba(255,193,7,0.3);border-radius:2px;padding:0 1px">$1</mark>');
      };

      let html =
        '<div class="bd-search-see-all bd-search-see-all--top">' +
          '<a href="' + seeAllUrl + '" class="bd-search-see-all__btn">' +
            'See all results for &ldquo;' + this._esc(q) + '&rdquo;' +
            '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>' +
          '</a>' +
        '</div>';

      html += '<div class="bd-search-dropdown__header">Top matches</div>';
      html += products.slice(0, 6).map(p =>
        '<a href="' + this._esc(p.url) + '" class="bd-search-result-item">' +
          '<img src="' + this._esc(p.featured_image?.url || '') + '" alt="' +
            this._esc(p.title) + '" onerror="this.style.visibility=\'hidden\'">' +
          '<div class="bd-search-result-item__info">' +
            '<div class="bd-search-result-item__name">' + hl(p.title, q) + '</div>' +
            '<div class="bd-search-result-item__price">' + this._money(p.price) + '</div>' +
          '</div>' +
        '</a>'
      ).join('');

      this.dropdown.innerHTML = html;
      this.dropdown.classList.add('active');
    },

    _close() { this.dropdown?.classList.remove('active'); },

    _voiceSearch() {
      const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SR) return;
      const r = new SR();
      r.lang = 'en-IN';
      r.start();
      r.onresult = (e) => {
        this.input.value = e.results[0][0].transcript;
        this._onInput();
      };
    },

    _money(cents) {
      if (!cents && cents !== 0) return '';
      const c = window.Shopify?.currency?.active;
      if (c === 'INR') return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: c || 'USD' });
    },

    _esc(s) {
      return String(s || '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  };

  /* ──────────────────────────────────────────
     FOR YOU — product recommendation sliders
  ──────────────────────────────────────────── */
  const BDForYou = {
    _shownUrls: new Set(),

    init() {
      const scroll1 = document.getElementById('bdForYouScroll1');
      const scroll2 = document.getElementById('bdForYouScroll2');
      const block1  = document.getElementById('bdForYouBlock1');
      const block2  = document.getElementById('bdForYouBlock2');
      if (!scroll1 && !scroll2) return;

      this._shownUrls = new Set();
      this._trackView();

      const loadSlider2 = () => {
        if (!scroll2) return;
        this._showSkeletons(scroll2);
        this._fetchFallback('created-descending', scroll2, block2);
      };

      if (scroll1) {
        this._showSkeletons(scroll1);
        this._fetchFallback('best-selling', scroll1, block1).then(loadSlider2);
      } else {
        loadSlider2();
      }
    },

    _trackView() {
      if (!window.location.pathname.startsWith('/products/')) return;
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0]?.split('/')[0];
      if (!handle) return;
      BDHistory.addView(handle.replace(/-/g, ' '));
      try {
        const raw = JSON.parse(localStorage.getItem('bd_view_handles') || '[]').filter(h => h !== handle);
        raw.unshift(handle);
        localStorage.setItem('bd_view_handles', JSON.stringify(raw.slice(0, 10)));
      } catch(_) {}
    },

    async _fetchFallback(sortBy, container, block) {
      try {
        const res  = await fetch('/collections/all/products.json?limit=12&sort_by=' + sortBy);
        const json = await res.json();
        const all = (json.products || []).map(p => ({
          title:      p.title,
          url:        '/products/' + p.handle,
          price:      p.variants?.[0]?.price ? Math.round(parseFloat(p.variants[0].price) * 100) : 0,
          compare_at_price: p.variants?.[0]?.compare_at_price ? Math.round(parseFloat(p.variants[0].compare_at_price) * 100) : 0,
          variant_id: p.variants?.[0]?.id || '',
          available:  p.variants?.[0]?.available !== false,
          featured_image: { url: p.images?.[0]?.src || '' }
        }));
        // Exclude anything already shown in the other slider
        const fresh = all.filter(p => !this._shownUrls.has(p.url)).slice(0, 8);
        if (fresh.length) {
          fresh.forEach(p => this._shownUrls.add(p.url));
          this._renderCards(container, fresh);
          return;
        }
        block?.remove();
      } catch (_) { block?.remove(); }
    },

    _showSkeletons(container) {
      container.innerHTML = Array(4).fill(0).map(() =>
        '<div class="bdfy-skeleton">' +
          '<div class="bdfy-skeleton__img"></div>' +
          '<div class="bdfy-skeleton__lines">' +
            '<div class="bdfy-skeleton__line"></div>' +
            '<div class="bdfy-skeleton__line bdfy-skeleton__line--s"></div>' +
          '</div>' +
        '</div>'
      ).join('');
    },

    _renderCards(container, products) {
      container.innerHTML = products.map(p => {
        const price = p.price ? '₹' + Math.round(p.price / 100).toLocaleString('en-IN') : '';
        const cmp   = p.compare_at_price && p.compare_at_price > p.price
                      ? '₹' + Math.round(p.compare_at_price / 100).toLocaleString('en-IN') : '';
        const img   = p.featured_image?.url || '';
        // variant_id: from fallback (p.variant_id) or from reco API variants array
        const vid   = p.variant_id || (p.variants && p.variants[0] && p.variants[0].id) || '';
        const avail = p.available !== false;
        return (
          '<div class="bd-product-card" data-variant-id="' + vid + '">' +
            '<a href="' + p.url + '" class="bd-product-card__link" style="text-decoration:none;display:block;">' +
              '<div class="bd-product-card__img-wrap">' +
                (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">' : '') +
              '</div>' +
              '<div class="bd-product-card__body">' +
                '<div class="bd-product-card__name">' + p.title + '</div>' +
                '<div class="bd-product-card__bottom"><div class="bd-product-card__prices">' +
                  '<span class="bd-product-card__price">' + price + '</span>' +
                  (cmp ? '<span class="bd-product-card__compare">' + cmp + '</span>' : '') +
                '</div></div>' +
              '</div>' +
            '</a>' +
            (avail && vid
              ? '<button class="bd-atc-btn" type="button" aria-label="Add to cart">+</button>' +
                '<div class="bd-qty-stepper">' +
                  '<button class="bd-qty-btn" data-action="minus" type="button">−</button>' +
                  '<span class="bd-qty-count">1</span>' +
                  '<button class="bd-qty-btn" data-action="plus" type="button">+</button>' +
                '</div>'
              : '<button class="bd-atc-btn" type="button" disabled style="opacity:.4;cursor:not-allowed">Sold out</button>') +
          '</div>'
        );
      }).join('');
    }
  };

  /* ──────────────────────────────────────────
     AJAX PRODUCT GRIDS
     Populates [data-bd-ajax-grid] sections via
     Shopify's /products.json — ensures true
     server-side sort (newest, price, etc.)
  ──────────────────────────────────────────── */
  const BDAjaxGrids = {
    init() {
      document.querySelectorAll('[data-bd-ajax-grid]').forEach(function(grid) {
        var sourceUrl = grid.dataset.url || '/collections/all?sort_by=created-descending';
        var limit     = parseInt(grid.dataset.limit) || 12;

        // Convert collection page URL → products.json API URL
        // /collections/all?sort_by=created-descending
        // → /collections/all/products.json?sort_by=created-descending&limit=12
        var apiUrl = sourceUrl
          .replace(/\/collections\/([^?]+)(\??.*)/, function(_, handle, query) {
            var params = new URLSearchParams(query.replace('?',''));
            params.set('limit', limit);
            return '/collections/' + handle + '/products.json?' + params.toString();
          });

        fetch(apiUrl)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.products || [];
            if (!products.length) {
              grid.innerHTML = '<p style="color:#999;font-size:14px;grid-column:1/-1">No products found.</p>';
              return;
            }
            grid.innerHTML = products.map(function(p) {
              var v     = p.variants && p.variants[0];
              var vid   = v ? v.id : '';
              var price = v && v.price ? '₹' + Math.round(parseFloat(v.price)).toLocaleString('en-IN') : '';
              var cmp   = v && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)
                          ? '₹' + Math.round(parseFloat(v.compare_at_price)).toLocaleString('en-IN') : '';
              var img   = p.images && p.images[0] ? p.images[0].src : '';
              var avail = !v || v.available !== false;
              return '<div class="bd-product-card" data-variant-id="' + vid + '">' +
                '<a href="/products/' + p.handle + '" class="bd-product-card__link" style="text-decoration:none;display:block;">' +
                  '<div class="bd-product-card__img-wrap">' +
                    (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g,'&quot;') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">' : '') +
                  '</div>' +
                  '<div class="bd-product-card__body">' +
                    '<div class="bd-product-card__name">' + p.title + '</div>' +
                    '<div class="bd-product-card__bottom"><div class="bd-product-card__prices">' +
                      '<span class="bd-product-card__price">' + price + '</span>' +
                      (cmp ? '<span class="bd-product-card__compare">' + cmp + '</span>' : '') +
                    '</div></div>' +
                  '</div>' +
                '</a>' +
                (avail && vid
                  ? '<button class="bd-atc-btn" type="button" aria-label="Add to cart">+</button>' +
                    '<div class="bd-qty-stepper">' +
                      '<button class="bd-qty-btn" data-action="minus" type="button">−</button>' +
                      '<span class="bd-qty-count">1</span>' +
                      '<button class="bd-qty-btn" data-action="plus" type="button">+</button>' +
                    '</div>'
                  : '<button class="bd-atc-btn" type="button" disabled style="opacity:.4;cursor:not-allowed">Sold out</button>') +
              '</div>';
            }).join('');
          })
          .catch(function() {
            grid.innerHTML = '<p style="color:#999;font-size:14px;grid-column:1/-1">Could not load products.</p>';
          });
      });
    }
  };


  const BDCart = {
    stickyEl: null,

    init() {
      this.stickyEl = document.getElementById('bdStickyCart');
      this.refresh();

      // Intercept native Shopify ATC forms — capture phase runs before theme's own handler
      document.addEventListener('submit', async (e) => {
        const form = e.target;
        if (!form.action || !form.action.includes('/cart/add')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const fd  = new FormData(form);
        const vid = fd.get('id');
        if (!vid) return;
        const qty = parseInt(fd.get('quantity'), 10) || 1;
        const btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.dataset.bdOrig = btn.textContent; btn.textContent = 'Adding…'; }
        const ok = await this.addItem(vid, qty);
        if (btn) {
          btn.disabled = false;
          btn.textContent = ok ? '✓ Added' : btn.dataset.bdOrig || 'Add to cart';
          if (ok) setTimeout(() => { btn.textContent = btn.dataset.bdOrig || 'Add to cart'; }, 1800);
        }
      }, { capture: true });
    },

    async addItem(variantId, qty = 1) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty })
        });
        if (!res.ok) throw new Error('add failed');
        await this.refresh();
        return true;
      } catch (e) {
        console.warn('[BDCart] addItem error', e);
        return false;
      }
    },

    async changeItem(variantId, qty) {
      try {
        const cart = await this._getCart();
        const item = cart.items.find(i => String(i.variant_id) === String(variantId));
        if (!item) return;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: qty })
        });
        await this.refresh();
      } catch (e) { console.warn('[BDCart] changeItem error', e); }
    },

    async refresh() {
      try {
        const cart = await this._getCart();
        this._updateSticky(cart);
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });
        const mobileBadge = document.querySelector('[data-mobile-cart-count]');
        if (mobileBadge) {
          if (cart.item_count > 0) {
            mobileBadge.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
            mobileBadge.style.display = 'flex';
          } else {
            mobileBadge.style.display = 'none';
          }
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (_) {}
    },

    async _getCart() {
      const res = await fetch('/cart.js');
      return res.json();
    },

    _updateSticky(cart) {
      if (!this.stickyEl) return;
      if (!cart.item_count) { this.stickyEl.classList.remove('visible'); return; }
      const countEl = this.stickyEl.querySelector('.bd-sticky-cart__count');
      const priceEl = this.stickyEl.querySelector('.bd-sticky-cart__price');
      if (countEl) countEl.textContent = cart.item_count + ' item' + (cart.item_count > 1 ? 's' : '');
      if (priceEl) priceEl.textContent  = this._money(cart.total_price);
      this.stickyEl.classList.add('visible');
    },

    _money(cents) {
      const c = window.Shopify?.currency?.active;
      if (c === 'INR') return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: c || 'USD' });
    }
  };

  /* ──────────────────────────────────────────
     QUANTITY STEPPERS
  ──────────────────────────────────────────── */
  const BDQty = {
    init() {
      // capture:true fires before <a> navigation and before Dawn's own handlers
      document.addEventListener('click', (e) => {
        if (e.target.closest('.bd-atc-btn:not(:disabled)')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const card = e.target.closest('.bd-product-card');
          if (!card) return;
          let variantId = card.dataset.variantId;
          if (!variantId) {
            const inp = card.querySelector('input[name="id"]') ||
                        e.target.closest('form')?.querySelector('input[name="id"]');
            variantId = inp?.value;
          }
          if (!variantId) return;
          this._showStepper(card);
          BDCart.addItem(variantId);
          return;
        }
        if (e.target.closest('.bd-qty-btn[data-action="plus"]')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const stepper = e.target.closest('.bd-qty-stepper');
          if (stepper) this._step(stepper, 1);
          return;
        }
        if (e.target.closest('.bd-qty-btn[data-action="minus"]')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const stepper = e.target.closest('.bd-qty-stepper');
          if (stepper) this._step(stepper, -1);
        }
      }, { capture: true });
    },

    _showStepper(card) {
      card.querySelector('.bd-atc-btn')?.classList.add('bd-hidden');
      const stepper = card.querySelector('.bd-qty-stepper');
      if (stepper) {
        stepper.classList.add('active');
        stepper.querySelector('.bd-qty-count').textContent = '1';
      }
    },

    _step(stepper, delta) {
      const countEl = stepper.querySelector('.bd-qty-count');
      const n       = parseInt(countEl.textContent, 10) + delta;
      const card    = stepper.closest('.bd-product-card');
      const vid     = card?.dataset.variantId;
      if (n <= 0) {
        stepper.classList.remove('active');
        card?.querySelector('.bd-atc-btn')?.classList.remove('bd-hidden');
        if (vid) BDCart.changeItem(vid, 0);
        return;
      }
      countEl.textContent = n;
      if (vid) BDCart.changeItem(vid, n);
    }
  };

  /* ──────────────────────────────────────────
     WISHLIST (localStorage)
  ──────────────────────────────────────────── */
  const BDWishlist = {
    KEY: 'bd_wl',

    init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.bd-product-card__wishlist');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        this._toggle(btn.dataset.productId, btn);
      });
      this._render();
    },

    _get() {
      try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch { return []; }
    },

    _toggle(id, btn) {
      let list = this._get();
      const idx = list.findIndex(p => (typeof p === 'object' ? p.id : p) === id);
      if (idx > -1) { list.splice(idx, 1); btn.classList.remove('active'); }
      else {
        list.push({
          id,
          handle:    btn.dataset.handle    || '',
          title:     btn.dataset.title     || '',
          price:     btn.dataset.price     || '',
          image:     btn.dataset.image     || '',
          url:       btn.dataset.url       || '',
          variantId: btn.dataset.variantId || ''
        });
        btn.classList.add('active');
      }
      localStorage.setItem(this.KEY, JSON.stringify(list));
      btn.style.transform = 'scale(1.35)';
      setTimeout(() => (btn.style.transform = ''), 250);
    },

    _render() {
      const list = this._get();
      const ids = list.map(p => typeof p === 'object' ? p.id : p);
      document.querySelectorAll('.bd-product-card__wishlist[data-product-id]').forEach(btn => {
        btn.classList.toggle('active', ids.includes(btn.dataset.productId));
      });
    },

    getAll() {
      return this._get().filter(p => typeof p === 'object' && p.id);
    }
  };

  /* ──────────────────────────────────────────
     CATEGORY TABS — highlight active
  ──────────────────────────────────────────── */
  const BDTabs = {
    init() {
      const path = window.location.pathname;
      document.querySelectorAll('.bd-category-tab').forEach(tab => {
        const href = tab.getAttribute('href');
        if (href && (href === path || path.startsWith(href + '/'))) {
          tab.classList.add('active');
          tab.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        }
      });
    }
  };


  /* ──────────────────────────────────────────
     DAWN CARD ENHANCER
     Injects "+ ADD → − 1 +" stepper into Dawn's
     native product cards on collection pages
  ──────────────────────────────────────────── */
  const BDDawnCards = {
    _cache: {},
    _timer: null,

    init() {
      this._scan();

      // Debounced scan — prevents infinite loops when our DOM changes trigger the observer
      const debouncedScan = () => {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this._scan(), 250);
      };

      // Observe MainContent (parent of ProductGridContainer) so we survive
      // Dawn's full innerHTML replacement of #ProductGridContainer during filtering
      const root = document.getElementById('MainContent') || document.body;
      new MutationObserver(debouncedScan).observe(root, { childList: true, subtree: true });

      document.addEventListener('shopify:section:reloaded', () => this._scan());
    },

    _scan() {
      document.querySelectorAll('.card-wrapper').forEach(el => this._enhance(el));
    },

    _enhance(el) {
      if (el.closest('.bd-product-card')) return;
      if (el.querySelector('.bd-dawn-atc')) return;

      const link = el.querySelector('a[href*="/products/"]');
      if (!link) return;
      const productPath = link.getAttribute('href').split('?')[0];

      const inp = el.querySelector('input[name="id"]');
      if (inp?.value) el.dataset.bdVariantId = inp.value;

      // Hide Dawn's native quick-add buttons
      el.querySelectorAll('.quick-add__submit, quick-add-button, .product-form__submit, .card__footer button, [name="add"]')
        .forEach(b => { b.style.cssText = 'display:none!important'; });

      const wrap = document.createElement('div');
      wrap.className = 'bd-dawn-atc';
      wrap.innerHTML =
        '<button class="bd-dawn-atc__btn" type="button">+ ADD</button>' +
        '<div class="bd-dawn-qty" role="group" aria-label="Quantity">' +
          '<button class="bd-dawn-qty__btn" data-d="−" type="button">−</button>' +
          '<span class="bd-dawn-qty__n">1</span>' +
          '<button class="bd-dawn-qty__btn" data-d="+" type="button">+</button>' +
        '</div>';
      // .card-information (no underscore) is the section BELOW the image.
      // .card__information (with underscore) is the overlay on top of the image — never insert there.
      const cardInfo = el.querySelector('.card-information');
      const priceEl  = el.querySelector('.price, .card__price');
      if (cardInfo) {
        cardInfo.appendChild(wrap);
      } else if (priceEl) {
        priceEl.insertAdjacentElement('afterend', wrap);
      } else {
        el.appendChild(wrap);
      }

      const atcBtn  = wrap.querySelector('.bd-dawn-atc__btn');
      const qtyWrap = wrap.querySelector('.bd-dawn-qty');
      const countEl = wrap.querySelector('.bd-dawn-qty__n');
      let qty = 0;

      const getVid = async () => {
        if (el.dataset.bdVariantId) return el.dataset.bdVariantId;
        const vid = await this._fetchVid(productPath);
        if (vid) el.dataset.bdVariantId = vid;
        return vid;
      };

      atcBtn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        atcBtn.disabled = true; atcBtn.textContent = '…';
        const vid = await getVid();
        atcBtn.disabled = false;
        if (!vid) { atcBtn.textContent = '+ ADD'; return; }
        const ok = await BDCart.addItem(vid, 1);
        if (ok) {
          qty = 1; countEl.textContent = 1;
          atcBtn.style.display = 'none';
          qtyWrap.classList.add('active');
        } else {
          atcBtn.textContent = '+ ADD';
        }
      });

      qtyWrap.addEventListener('click', async (e) => {
        const dir = e.target.closest('[data-d]')?.dataset.d;
        if (!dir) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const vid = el.dataset.bdVariantId;
        if (!vid) return;
        if (dir === '−') {
          if (qty <= 1) {
            qty = 0;
            qtyWrap.classList.remove('active');
            atcBtn.style.display = '';
            atcBtn.textContent = '+ ADD';
            BDCart.changeItem(vid, 0);
          } else { qty--; countEl.textContent = qty; BDCart.changeItem(vid, qty); }
        } else { qty++; countEl.textContent = qty; BDCart.addItem(vid, 1); }
      });
    },

    async _fetchVid(path) {
      if (this._cache[path]) return this._cache[path];
      try {
        const r  = await fetch(path + '.json');
        const d  = await r.json();
        const v  = d.product?.variants?.find(v => v.available) || d.product?.variants?.[0];
        const id = v?.id ? String(v.id) : null;
        if (id) this._cache[path] = id;
        return id;
      } catch { return null; }
    }
  };

  /* ──────────────────────────────────────────
     PRODUCT PAGE STEPPER
     After ATC on the product detail page, the
     button transforms into a − qty + stepper
  ──────────────────────────────────────────── */
  const BDProductStepper = {
    init() {
      const form   = document.querySelector('form[action*="/cart/add"]');
      const atcBtn = form?.querySelector('.product-form__submit');
      if (!atcBtn) return;

      const stpr = document.createElement('div');
      stpr.className = 'bd-ppstep';
      stpr.innerHTML =
        '<button class="bd-ppstep__btn" data-d="−" type="button" aria-label="Decrease">−</button>' +
        '<span class="bd-ppstep__n" aria-live="polite">1</span>' +
        '<button class="bd-ppstep__btn" data-d="+" type="button" aria-label="Increase">+</button>';
      stpr.style.display = 'none';
      atcBtn.insertAdjacentElement('afterend', stpr);

      const cntEl = stpr.querySelector('.bd-ppstep__n');
      const curVid = () => form.querySelector('input[name="id"]')?.value;
      let qty = 0;

      const show = (q) => { qty = q; cntEl.textContent = q; atcBtn.style.display = 'none'; stpr.style.display = 'flex'; };
      const hide = () => { atcBtn.style.display = ''; stpr.style.display = 'none'; qty = 0; };

      document.addEventListener('cart:updated', (e) => {
        const vid  = curVid();
        const item = e.detail?.cart?.items?.find(i => String(i.variant_id) === String(vid));
        if (item?.quantity > 0) show(item.quantity); else hide();
      });

      const idInp = form.querySelector('input[name="id"]');
      if (idInp) new MutationObserver(hide).observe(idInp, { attributes: true, attributeFilter: ['value'] });

      stpr.addEventListener('click', async (e) => {
        const dir = e.target.closest('[data-d]')?.dataset.d;
        if (!dir) return;
        e.preventDefault(); e.stopPropagation();
        const vid = curVid();
        if (!vid) return;
        if (dir === '−') {
          if (qty <= 1) { BDCart.changeItem(vid, 0); hide(); }
          else { qty--; cntEl.textContent = qty; BDCart.changeItem(vid, qty); }
        } else { qty++; cntEl.textContent = qty; BDCart.addItem(vid, 1); }
      });
    }
  };

  /* ──────────────────────────────────────────
     RECENTLY VIEWED
  ──────────────────────────────────────────── */
  const BDRecentlyViewed = {
    init() {
      const scroll = document.getElementById('bdRVScroll');
      if (!scroll) return;
      let handles;
      try { handles = JSON.parse(localStorage.getItem('bd_view_handles') || '[]'); } catch(_) { handles = []; }
      if (!handles.length) { this._removeSection(scroll); return; }
      const currentHandle = window.location.pathname.replace(/^\/products\//, '').split('?')[0].split('/')[0];
      handles = handles.filter(h => h !== currentHandle).slice(0, 8);
      if (!handles.length) { this._removeSection(scroll); return; }
      Promise.all(handles.map(h =>
        fetch('/products/' + h + '.json').then(r => r.ok ? r.json() : null).catch(() => null)
      )).then(results => {
        let cards = '';
        results.forEach(data => {
          if (!data?.product) return;
          const p = data.product, v = p.variants?.[0];
          const vid = v ? String(v.id) : '';
          const img = p.images?.[0]?.src || '';
          const price = v?.price ? '₹' + Math.round(parseFloat(v.price)).toLocaleString('en-IN') : '';
          cards += '<div class="bd-product-card" data-variant-id="' + vid + '">' +
            '<a href="/products/' + p.handle + '" class="bd-product-card__link" style="text-decoration:none;display:block;">' +
              '<div class="bd-product-card__img-wrap">' + (img ? '<img src="' + img + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;">' : '') + '</div>' +
              '<div class="bd-product-card__body"><div class="bd-product-card__name">' + p.title + '</div>' +
                '<div class="bd-product-card__bottom"><div class="bd-product-card__prices"><span class="bd-product-card__price">' + price + '</span></div></div>' +
              '</div></a>' +
            (vid ? '<button class="bd-atc-btn" type="button">+ ADD</button><div class="bd-qty-stepper"><button class="bd-qty-btn" data-action="minus" type="button">−</button><span class="bd-qty-count">1</span><button class="bd-qty-btn" data-action="plus" type="button">+</button></div>' : '') +
          '</div>';
        });
        if (!cards) { this._removeSection(scroll); return; }
        scroll.innerHTML = cards;
      });
    },
    _removeSection(el) { el.closest('.bd-recently-viewed')?.remove(); }
  };

  /* ──────────────────────────────────────────
     CUSTOMER MODE  (B2B — show to shoppers)
  ──────────────────────────────────────────── */
  const BDCustomerMode = {
    KEY: 'bd_customer_mode',
    init() {
      // Restore mode from previous session
      if (localStorage.getItem(this.KEY) === '1') {
        document.body.classList.add('bd-customer-mode');
      }
      // When mode is active, show a small floating exit button so they can leave
      // The enter button lives in the account page (bd-account-tools section)
      if (document.body.classList.contains('bd-customer-mode')) {
        this._injectExitBtn();
      }
    },
    _injectExitBtn() {
      if (document.getElementById('bdCustExitBtn')) return;
      const btn = document.createElement('button');
      btn.id = 'bdCustExitBtn';
      btn.className = 'bd-cust-mode-btn active';
      btn.textContent = '🛍 Exit Customer View';
      btn.setAttribute('aria-label', 'Exit customer view');
      document.body.appendChild(btn);
      btn.addEventListener('click', () => {
        document.body.classList.remove('bd-customer-mode');
        localStorage.setItem(this.KEY, '0');
        btn.remove();
      });
    }
  };

  /* ──────────────────────────────────────────
     WISHLIST PAGE  (share catalogue)
  ──────────────────────────────────────────── */
  const BDWishlistPage = {
    init() {
      const grid = document.getElementById('bdWishlistGrid');
      if (!grid) return;
      const items = BDWishlist.getAll();
      if (!items.length) {
        grid.innerHTML = '<p style="color:#999;font-size:15px;grid-column:1/-1;text-align:center;padding:40px 0">No saved products yet.<br>Tap the ♥ on any product to save it here.</p>';
        return;
      }
      grid.innerHTML = items.map(item => {
        const vid = item.variantId ? String(item.variantId) : '';
        const url = item.url || '/products/' + item.handle;
        const img = item.image || '';
        const price = item.price ? '₹' + Math.round(parseInt(item.price, 10) / 100).toLocaleString('en-IN') : '';
        return '<div class="bd-product-card" data-variant-id="' + vid + '">' +
          '<a href="' + url + '" class="bd-product-card__link" style="text-decoration:none;display:block;">' +
            '<div class="bd-product-card__img-wrap">' + (img ? '<img src="' + img + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;">' : '') + '</div>' +
            '<div class="bd-product-card__body"><div class="bd-product-card__name">' + (item.title || '') + '</div>' +
              '<div class="bd-product-card__bottom"><div class="bd-product-card__prices"><span class="bd-product-card__price">' + price + '</span></div></div>' +
            '</div></a>' +
          (vid ? '<button class="bd-atc-btn" type="button">+ ADD</button><div class="bd-qty-stepper"><button class="bd-qty-btn" data-action="minus" type="button">−</button><span class="bd-qty-count">1</span><button class="bd-qty-btn" data-action="plus" type="button">+</button></div>' : '') +
        '</div>';
      }).join('');

      // Wire share buttons
      document.getElementById('bdWLWhatsApp')?.addEventListener('click', () => this.shareWhatsApp());
      document.getElementById('bdWLPrint')?.addEventListener('click', () => window.print());
      document.getElementById('bdWLCopyLink')?.addEventListener('click', () => this.copyLink());
    },

    shareWhatsApp() {
      const items = BDWishlist.getAll();
      if (!items.length) { alert('Wishlist is empty.'); return; }
      const lines = items.map((p, i) => {
        const price = p.price ? '₹' + Math.round(parseInt(p.price, 10) / 100).toLocaleString('en-IN') : '';
        return (i + 1) + '. *' + (p.title || '') + '* — ' + price + '\n   ' + window.location.origin + (p.url || '/products/' + p.handle);
      });
      window.open('https://wa.me/?text=' + encodeURIComponent('🛍 *Product Catalogue*\n\n' + lines.join('\n\n')), '_blank');
    },

    copyLink() {
      const items = BDWishlist.getAll();
      if (!items.length) { alert('Wishlist is empty.'); return; }
      const handles = items.map(p => p.handle).filter(Boolean);
      const url = window.location.origin + '/pages/catalogue?p=' + handles.join(',');
      navigator.clipboard?.writeText(url).then(() => alert('Link copied!'))
        .catch(() => alert('Copy this link:\n' + url));
    }
  };

  /* ──────────────────────────────────────────
     CATALOGUE PAGE  (shared read-only view)
  ──────────────────────────────────────────── */
  const BDCataloguePage = {
    init() {
      const grid = document.getElementById('bdCatalogueGrid');
      if (!grid) return;
      const handles = (new URLSearchParams(window.location.search).get('p') || '').split(',').map(h => h.trim()).filter(Boolean);
      if (!handles.length) { grid.innerHTML = '<p style="color:#999;padding:40px;text-align:center">No products in this catalogue.</p>'; return; }
      grid.innerHTML = '<p style="color:#999;padding:20px;text-align:center">Loading...</p>';
      Promise.all(handles.map(h =>
        fetch('/products/' + h + '.json').then(r => r.ok ? r.json() : null).catch(() => null)
      )).then(results => {
        let cards = '';
        results.forEach(data => {
          if (!data?.product) return;
          const p = data.product, v = p.variants?.[0];
          const img = p.images?.[0]?.src || '';
          const retail = v?.compare_at_price && parseFloat(v.compare_at_price) > 0
            ? '₹' + Math.round(parseFloat(v.compare_at_price)).toLocaleString('en-IN')
            : (v?.price ? '₹' + Math.round(parseFloat(v.price)).toLocaleString('en-IN') : '');
          cards += '<div class="bd-product-card">' +
            '<a href="/products/' + p.handle + '" class="bd-product-card__link" style="text-decoration:none;display:block;">' +
              '<div class="bd-product-card__img-wrap">' + (img ? '<img src="' + img + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;">' : '') + '</div>' +
              '<div class="bd-product-card__body"><div class="bd-product-card__name">' + p.title + '</div>' +
                '<div class="bd-product-card__bottom"><div class="bd-product-card__prices"><span class="bd-product-card__price">' + retail + '</span></div></div>' +
              '</div></a>' +
          '</div>';
        });
        grid.innerHTML = cards || '<p style="color:#999;padding:40px;text-align:center">Could not load products.</p>';
      });
    }
  };

  /* ──────────────────────────────────────────
     BOOT
  ──────────────────────────────────────────── */
  /* ──────────────────────────────────────────
     PWA — service worker + install prompt
  ──────────────────────────────────────────── */
  var BDPWA = {
    _deferredPrompt: null,
    _registration: null,
    _VAPID_PUB: 'BN4czA94EcQLCb63aHxWwqTkCUHPsTJPs0rLEHMtFfkj6AGBQ1uAQTWm505ELa2pSWNtDo__IIW7CZ0A_1cuL5M',
    _PUSH_API: 'https://thegiftwholesalers.com/push',
    init: function() {
      if (!('serviceWorker' in navigator)) return;

      navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(function(reg) {
        BDPWA._registration = reg;
      }).catch(function(err) {
        console.warn('BD SW registration failed:', err);
      });

      window.addEventListener('beforeinstallprompt', function(e) {
        e.preventDefault();
        BDPWA._deferredPrompt = e;
        BDPWA._showBanner();
      });

      window.addEventListener('appinstalled', function() {
        BDPWA._hideBanner();
        BDPWA._deferredPrompt = null;
      });
    },
    enablePush: function(callback) {
      if (!('Notification' in window) || !BDPWA._registration) {
        if (callback) callback(false, 'Not supported');
        return;
      }
      Notification.requestPermission().then(function(perm) {
        if (perm !== 'granted') { if (callback) callback(false, 'Permission denied'); return; }
        var pad = (4 - BDPWA._VAPID_PUB.length % 4) % 4;
        var b64 = BDPWA._VAPID_PUB.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat(pad);
        var raw = atob(b64);
        var key = new Uint8Array(raw.length);
        for (var i = 0; i < raw.length; i++) key[i] = raw.charCodeAt(i);
        BDPWA._registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: key
        }).then(function(sub) {
          return fetch(BDPWA._PUSH_API + '/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(sub)
          });
        }).then(function() {
          if (callback) callback(true);
        }).catch(function(err) {
          if (callback) callback(false, err.message);
        });
      });
    },
    _showBanner: function() {
      if (document.getElementById('bdPwaBanner')) return;
      var banner = document.createElement('div');
      banner.id = 'bdPwaBanner';
      banner.innerHTML = '<span>Install our app for faster browsing</span>' +
        '<button id="bdPwaInstall">Install</button>' +
        '<button id="bdPwaClose">x</button>';
      banner.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#1A1A2E;color:#fff;' +
        'padding:12px 16px;display:flex;align-items:center;gap:10px;z-index:99999;font-size:13px;' +
        'font-family:system-ui,sans-serif;';
      banner.querySelector('#bdPwaInstall').style.cssText = 'background:#fff;color:#1A1A2E;border:none;' +
        'padding:7px 16px;border-radius:20px;font-weight:700;cursor:pointer;font-size:12px;margin-left:auto;';
      banner.querySelector('#bdPwaClose').style.cssText = 'background:none;border:none;color:#fff;' +
        'cursor:pointer;font-size:16px;padding:4px 8px;';
      banner.querySelector('#bdPwaInstall').addEventListener('click', function() { BDPWA.install(); });
      banner.querySelector('#bdPwaClose').addEventListener('click', function() { BDPWA._hideBanner(); });
      document.body.appendChild(banner);
    },
    _hideBanner: function() {
      var b = document.getElementById('bdPwaBanner');
      if (b) b.remove();
    },
    install: function() {
      if (!BDPWA._deferredPrompt) return;
      BDPWA._deferredPrompt.prompt();
      BDPWA._deferredPrompt.userChoice.then(function() {
        BDPWA._deferredPrompt = null;
        BDPWA._hideBanner();
      });
    }
  };

  /* ──────────────────────────────────────────
     CART SAVE — persist cart to localStorage
     Shows restore banner when cart is empty but saved items exist
  ──────────────────────────────────────────── */
  var BDCartSave = {
    KEY: 'bd_saved_cart',
    _origFetch: window.fetch.bind(window),

    init: function() {
      this._watchCart();
      this._checkRestore();
    },

    _watchCart: function() {
      var self = this;
      var orig = this._origFetch;
      window.fetch = function(input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isMutation = /\/cart\/(add|change|update|clear)/.test(url);
        var result = orig.apply(this, arguments);
        if (isMutation) {
          result.then(function() {
            setTimeout(function() {
              orig('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                if (cart.item_count > 0) {
                  self._save(cart.items);
                } else {
                  localStorage.removeItem(self.KEY);
                  var banner = document.getElementById('bdCartBanner');
                  if (banner) banner.remove();
                }
              });
            }, 400);
          });
        }
        return result;
      };
    },

    _save: function(items) {
      var data = items.map(function(item) {
        return { id: item.variant_id, quantity: item.quantity, title: item.title, price: item.price };
      });
      localStorage.setItem(this.KEY, JSON.stringify(data));
    },

    _getSaved: function() {
      try { return JSON.parse(localStorage.getItem(this.KEY) || 'null'); } catch(e) { return null; }
    },

    _checkRestore: function() {
      var saved = this._getSaved();
      if (!saved || !saved.length) return;
      var self = this;
      this._origFetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        if (cart.item_count === 0) self._showBanner(saved);
        else self._save(cart.items);
      });
    },

    _showBanner: function(saved) {
      if (document.getElementById('bdCartBanner')) return;
      var total = saved.reduce(function(s, i) { return s + i.quantity; }, 0);
      var banner = document.createElement('div');
      banner.id = 'bdCartBanner';
      banner.style.cssText = 'position:fixed;bottom:70px;left:12px;right:12px;background:#1A1A2E;color:#fff;' +
        'border-radius:16px;padding:14px 16px;display:flex;align-items:center;gap:10px;z-index:8999;' +
        'box-shadow:0 8px 32px rgba(0,0,0,0.25);font-family:system-ui,sans-serif;font-size:13px;';
      banner.innerHTML =
        '<span style="flex:1;font-weight:600;">&#128722; You left <strong>' + total + ' item' + (total > 1 ? 's' : '') + '</strong> in your cart</span>' +
        '<button onclick="BDCartSave.restore()" style="background:#FF8F00;color:#fff;border:none;border-radius:20px;' +
        'padding:8px 16px;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Restore</button>' +
        '<button onclick="BDCartSave.dismiss()" style="background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0 4px;line-height:1;">&#x2715;</button>';
      document.body.appendChild(banner);
    },

    restore: function() {
      var saved = this._getSaved();
      if (!saved || !saved.length) return;
      var banner = document.getElementById('bdCartBanner');
      if (banner) banner.querySelector('button').textContent = 'Restoring…';
      var self = this;
      Promise.all(saved.map(function(item) {
        return self._origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.id, quantity: item.quantity })
        });
      })).then(function() {
        localStorage.removeItem(self.KEY);
        window.location.href = '/cart';
      }).catch(function() {
        if (banner) banner.remove();
      });
    },

    dismiss: function() {
      localStorage.removeItem(this.KEY);
      var banner = document.getElementById('bdCartBanner');
      if (banner) banner.remove();
    }
  };

  function boot() {
    window.scrollTo({ top: 0, behavior: 'instant' });
    BDSearch.init();
    BDForYou.init();
    BDAjaxGrids.init();
    BDQty.init();
    BDCart.init();
    BDWishlist.init();
    BDTabs.init();
    BDDawnCards.init();
    BDProductStepper.init();
    BDRecentlyViewed.init();
    BDCustomerMode.init();
    BDWishlistPage.init();
    BDCataloguePage.init();
    BDPWA.init();
    BDCartSave.init();
  }

  window.BDCartSave = BDCartSave;

  /* ──────────────────────────────────────────
     PRODUCT GRID — force 4 columns on desktop
     Only on homepage; collection pages use CSS grid
  ──────────────────────────────────────────── */
  function forceProductGridColumns() {
    if (window.innerWidth < 990) return;
    // Skip collection/search pages — CSS handles their grid
    var body = document.body;
    if (body.classList.contains('template-collection') ||
        body.classList.contains('template-search')) return;
    var grids = document.querySelectorAll('.product-grid');
    grids.forEach(function (g) {
      g.style.setProperty('display', 'grid', 'important');
      g.style.setProperty('grid-template-columns', 'repeat(4, minmax(0, 1fr))', 'important');
      g.style.setProperty('gap', '20px', 'important');
      g.querySelectorAll('.grid__item').forEach(function (item) {
        item.style.setProperty('width', '100%', 'important');
        item.style.setProperty('max-width', '100%', 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      forceProductGridColumns();
    });
  } else {
    boot();
    forceProductGridColumns();
  }

})();
